import moment from 'moment';

/**
 * Location "wall clock" now, matching DatepickerModule's existing Timezone offset pattern.
 * Returned moment is in utc-mode but represents local restaurant time.
 * Keep utc-mode (do not re-parse via moment(format())) so startOf('day') uses
 * location wall-clock, not the browser timezone.
 */
export const getLocationWallClockNow = (Timezone) => {
  return moment().utc().add(Number(Timezone), 'hours');
};

/**
 * Calendar-day [from, to] for Analytics Today / Yesterday (location local midnight → end of day).
 *
 * @param {Object} params
 * @param {number|string} params.Timezone - hours offset from UTC (location.Timezone)
 * @param {0|-1} params.dayOffset - 0 = calendar today, -1 = calendar yesterday
 * @returns {[string, string]}
 */
export const getAnalyticsCalendarDayRange = ({Timezone, dayOffset = 0}) => {
  const targetDay = getLocationWallClockNow(Timezone)
    .clone()
    .utc()
    .add(dayOffset, 'days');

  return [
    targetDay.clone().startOf('day').format(),
    targetDay.clone().endOf('day').format()
  ];
};

export const getAnalyticsTodayRange = ({Timezone}) =>
  getAnalyticsCalendarDayRange({Timezone, dayOffset: 0});

export const getAnalyticsYesterdayRange = ({Timezone}) =>
  getAnalyticsCalendarDayRange({Timezone, dayOffset: -1});
